<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6016 4.59961V10.5996L14.6016 12.5996M20.6016 10.5996C20.6016 16.1225 16.1244 20.5996 10.6016 20.5996C5.07871 20.5996 0.601562 16.1225 0.601562 10.5996C0.601562 5.07676 5.07871 0.599609 10.6016 0.599609C16.1244 0.599609 20.6016 5.07676 20.6016 10.5996Z" stroke="#8D959D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
